import React, { useState } from 'react';
import { defineMessages } from 'react-intl-next';

import { Stack, xcss } from '@atlaskit/primitives';
import CloseIcon from '@atlaskit/icon/core/close';
import ArchiveBoxIcon from '@atlaskit/icon/core/archive-box';
import DeleteIcon from '@atlaskit/icon/core/delete';

import { BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT } from '@confluence/bulk-page-actions';
import { BULK_ARCHIVE_PAGE_SELECTION_LIMIT } from '@confluence/archive-pages';

import { useContentTreeSelection } from '../store';

import { BulkActionsButton } from './BulkActionsButton';

export const BulkActionsMenu = () => {
	const [{ count, loadingDescendantIds }, { clearSelection }] = useContentTreeSelection();

	const isDeleteButtonDisabled = count > BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT;
	const isArchiveButtonDisabled = count > BULK_ARCHIVE_PAGE_SELECTION_LIMIT;

	const [shouldShowDeleteLimitDialog, setShouldShowDeleteLimitDialog] = useState(false);
	const [shouldShowArchiveLimitDialog, setShouldShowArchiveLimitDialog] = useState(false);
	return (
		<Stack space="space.100" alignBlock="start" xcss={menuStyles}>
			<BulkActionsButton
				actionText={i18n.selected}
				actionIcon={<CloseIcon label="" />}
				onClick={clearSelection}
				isLoading={loadingDescendantIds.size > 0}
				count={count}
			/>
			<BulkActionsButton
				actionText={i18n.archive}
				actionIcon={<ArchiveBoxIcon label="" />}
				onClick={() => {}}
				isActionDisabled={isArchiveButtonDisabled}
				shouldShowLimitDialog={shouldShowArchiveLimitDialog}
				updateShouldShowLimitDialog={setShouldShowArchiveLimitDialog}
				actionLimit={BULK_ARCHIVE_PAGE_SELECTION_LIMIT}
			/>
			<BulkActionsButton
				actionText={i18n.delete}
				actionIcon={<DeleteIcon label="" />}
				onClick={() => {}}
				isActionDisabled={isDeleteButtonDisabled}
				shouldShowLimitDialog={shouldShowDeleteLimitDialog}
				updateShouldShowLimitDialog={setShouldShowDeleteLimitDialog}
				actionLimit={BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT}
			/>
		</Stack>
	);
};

const i18n = defineMessages({
	selected: {
		id: 'content-tree-actions.bulk-actions-menu.selected',
		defaultMessage: '{count, plural, one {# item} other {# items}} selected',
		description: 'The label displaying the number of items selected in the bulk actions menu',
	},
	archive: {
		id: 'content-tree-actions.bulk-actions-menu.archive',
		defaultMessage: 'Archive',
		description: 'The label for the archive action in the bulk actions menu',
	},
	delete: {
		id: 'content-tree-actions.bulk-actions-menu.delete',
		defaultMessage: 'Delete',
		description: 'The label for the delete action in the bulk actions menu',
	},
});

const menuStyles = xcss({
	position: 'fixed',
	top: 'calc(316px + var(--topNavigationHeight, 0px))',
	left: 'calc(9px + var(--leftSidebarWidth, 0px))',
});
